<app-base-modal [title]="'user.view.modal.title' | translate">
	<app-user-form [user]="user" [readonly]="true"/>
</app-base-modal>
